import { useCallback } from 'react';
import { routes } from 'routes/routes';

export const useGenerateInvitationLink = () =>
  useCallback(
    ({ eventId, token }: { eventId: string; token: string }) =>
      `${window.location.origin}${routes.events.share(eventId, token)}`,
    [],
  );
